import { useMutation } from 'react-query'

import { getRouteApi, useNavigate } from '@tanstack/react-router'
import { PortalName } from 'commons/types/enums'
import { setPassword } from '~auth/service/user'

import { useLogout } from '../user/useLogout'

export const useSetPassword = (p: PortalName) => {
  const { logout } = useLogout()
  const navigate = useNavigate()
  const returnUrl = getRouteApi('/_auth/auth/password-reset').useSearch({ select: (s) => s?.returnUrl })

  return useMutation((data: { key: string; password: string }) => setPassword(p, data.key, data.password), {
    onError: (error: Error) => {
      throw error
    },
    onSuccess: async () => {
      await logout({ returnUrl })
      navigate({ to: '/auth/login' })
    }
  })
}
